import _get from 'lodash/get';
import _without from 'lodash/without';
import { Option, Values } from '@lib/interfaces/form';
import { PredefinedValues } from '@lib/enums/form';
import mergeAndUnlinkMultiSelectValues from '@lib/utils/mergeAndUnlinkMultiSelectValues';

export default function getItemMemberships<T>(
  values: Values,
  prevValues: T,
  name: string,
) {
  const itemMemberships = _get(values, name) as Values;
  const newItemMemberships = Array.isArray(itemMemberships)
    ? (_without(
        itemMemberships.map((itemMembershipitemm) => {
          if (!itemMembershipitemm) return undefined;
          return { id: itemMembershipitemm.value };
        }),
        undefined,
      ) as { id: string }[])
    : [];
  const isSelectAllOptionSelected = newItemMemberships.some(
    ({ id }) => id === PredefinedValues.all,
  );
  const prevItems = _get(prevValues, name, []) as Option[];
  const prevIds = prevItems
    .filter(({ value }) => value !== PredefinedValues.all)
    .map(({ value }) => ({ id: value as string }));
  return isSelectAllOptionSelected
    ? null
    : mergeAndUnlinkMultiSelectValues(prevIds, newItemMemberships);
}
